const icons = [
  require("./checkbox-filled.svg"),
  require("./cross-icon.svg"),
  require("./eye-off.svg"),
  require("./eye.svg"),
  require("./password-switch-off.svg"),
  require("./password-switch-on.svg"),
  require("./radio-filled.svg"),
  require("./radio-unfilled.svg"),
  require("./search-line.svg"),
  require("./search.svg"),
  require("./switch-off-themed.svg"),
  require("./switch-off.svg"),
  require("./switch-on-themed.svg"),
  require("./switch-on.svg"),
];

export default icons;
